export default {"src":"/_next/static/media/mastercard.a6ee3a28.svg","height":24,"width":35,"blurWidth":0,"blurHeight":0};